import * as APPCONFIG from "../../src/config/app-config";
import auth from "./AuthAPI.js";
import Http from "./Http.js";

export const updateAdminSetting = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/admin-settings/updateAdminSetting`,
    data: JSON.stringify(form),
    headers: Http.AUTH_HEADERS(),
  });
};

export const updateAdminSecurity = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/admin-settings/updateAdminSecurity`,
    data: JSON.stringify(form),
    headers: Http.AUTH_HEADERS(),
  });
};

export const getSettingDetails = () => {
  return auth({
    method: "get",
    url: `${APPCONFIG.API_URL}auth/admin-settings/getSettingDetails`,
    headers: Http.AUTH_HEADERS(),
  });
};

export const updateSettingsLimit = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/system-limits/updateSettings`,
    data: JSON.stringify(form),
    headers: Http.AUTH_HEADERS(),
  });
};

export const updateSettingsFee = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/fee-config/updateSettings`,
    data: JSON.stringify(form),
    headers: Http.AUTH_HEADERS(),
  });
};
